package br.com.texeratx.boardgametimeapp.ui.components

import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import br.com.texeratx.boardgametimeapp.core.i18n.LocalStrings

@Composable
fun FinishActiveMatchDialog(
    onDismiss: () -> Unit,
    onConfirmFinish: () -> Unit
) {
    val S = LocalStrings.current
    AlertDialog(
        onDismissRequest = onDismiss,
        title = { Text(S.dialogFinishMatch) },
        text = { Text(S.dialogFinishMatchConfirm) },
        confirmButton = {
            TextButton(onClick = onConfirmFinish) {
                Text(S.finish)
            }
        },
        dismissButton = {
            TextButton(onClick = onDismiss) {
                Text(S.cancel)
            }
        }
    )
}
